import React, { useEffect, useState } from 'react'
import { Modal as ReactBootstrapModal } from 'react-bootstrap'
import { useIntl } from 'react-intl'
import { CustomSelectPipelineLogLead } from '../CustomComponentSelect/CustomSelect'
import VirtualizedSelect from '../../Select/SelectVirtualized'
import { useDataTableStore } from '../../../stores/DataTableStore'
import { SelectOption } from '../../../interfaces/SelectOption'
import { useSettingsStore } from '../../../stores/SettingsStore'
import moment from 'moment'
import { usePipelineStore } from '../../../stores/PipelineStore'
import { currencyFormatter, customNumberFormat, getDateSummary } from '../../../functions/general'
import useUser from '../../../hooks/User'
import { useCustomeStore } from '../../../stores/CustomeStore'
import { ExpandableElement } from '../../General/ExpandableElement'
import useLogLeadTempStore from '../../../stores/LogLeadTemp'
import { returnMerchantNamePipeline, returnProduct, returnProgress, returnQtyProduct, returnSource } from '../../General/DetailMasterElement'

interface BtnActionSelectPipelineProps {
    showModal: boolean
    handleModalClose: () => void
    setShowModalAddLog: (show: boolean) => void
}

const BtnActionSelectPipeline = ({ showModal, handleModalClose, setShowModalAddLog }: BtnActionSelectPipelineProps) => {
    const intl = useIntl()
    const { settings } = useSettingsStore()
    const { tablesData } = useDataTableStore()
    const [dataOptionsPipeline, setDataOptionsPipeline] = useState<SelectOption[]>([])
    const { selectedPipelineLogTemp, setSelectedPipelineLogTemp, selectMultiPipeline } = usePipelineStore()
    const [selectedDataPipeline, setSelectedDataPipeline] = useState<any>(null)
    const user = useUser()
    const { companyId, keyCustomfield } = useCustomeStore()
    const { getLatestLogLeadTempByLeadId, getLengthLogSameLeadId, getNominalLogSameLeadId } = useLogLeadTempStore()

    useEffect(() => {
        if (tablesData['pipelines'] && tablesData['pipelines'].length > 0) {
            const data = tablesData['pipelines'].map((item) => {
                return {
                    value: item.id,
                    label: `${item.merchant_name} / ${item.owner_name} / ${moment(item.date_start).format("DD MMM YYYY")} / ${currencyFormatter(item.nominal, selectMultiPipeline.currencyIsRounded, selectMultiPipeline.currencyCode, { showPrefix: true })}`,
                    merchant_name: item.merchant_name,
                    owner_name: item.owner_name,
                    date_start: item.date_start,
                    nominal: item.nominal,
                }
            })
            setDataOptionsPipeline(data)
        }
    }, [tablesData['pipelines']])

    const handleChangeSelectedPipeline = (option: SelectOption) => {
        const getPipeline = tablesData['pipelines'].find((item) => item.id === option.value)

        const getData = getLatestLogLeadTempByLeadId(option.value)
        const getLengthLog = getLengthLogSameLeadId(option.value)
        const getNominal = getNominalLogSameLeadId(option.value)

        const newValuesPipeline = {
            ...getPipeline,
            custom_fields: getData?.customFields,
            leadProducts: getData?.leadProducts,
            termins: getData?.termins,
            lead_progress_name: getData?.progressName,
            lead_subprogress_name: getData?.subProgressName,
            lead_progress_color: getData?.leadProgressColor,
            lead_logs_count: getPipeline.lead_logs_count + getLengthLog,
            nominal: getNominal
        }

        if (getPipeline && !getData) {
            setSelectedPipelineLogTemp(getPipeline)
        } else if (getData && getPipeline) {
            setSelectedPipelineLogTemp(newValuesPipeline)
        }
    }

    useEffect(() => {
        if (selectedPipelineLogTemp) {
            setSelectedDataPipeline(selectedPipelineLogTemp)
        }
    }, [selectedPipelineLogTemp])

    useEffect(() => {
        if (selectedPipelineLogTemp && Object.keys(selectedPipelineLogTemp).length > 0) {
            const data = selectedPipelineLogTemp as any
            const customData: any = {
                date_created: {
                    name: intl.formatMessage({ id: 'MASTERS.DATATABLE.TYPE.DATE_CREATED' }),
                    value: moment(data.date_created).format("DD MMM YYYY HH:mm")
                },
                merchant: {
                    name: intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.NAME_TITLE' }, { title: settings.merchant_title }),
                    value: returnMerchantNamePipeline(data)
                },
                pic: {
                    name: intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.PIC' }),
                    value: data.owner_name
                },
                total_log: {
                    name: intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.TOTAL_LOGS' }),
                    value: data.lead_logs_count && customNumberFormat(data.lead_logs_count)
                },
                progress: {
                    name: intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.PROGRESS' }),
                    value: returnProgress(data, intl, companyId, user)
                },
                phone: {
                    name: intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.PHONE' }),
                    value: data.merchant_phone
                },
                age: {
                    name: intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.AGE' }),
                    value: getDateSummary(data.lead_age)
                },
                source: {
                    name: intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.SOURCE' }),
                    value: returnSource(data)
                },
                product: {
                    name: intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.PRODUCT' }),
                    value: returnProduct(data)
                },
                nominal: {
                    name: intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.NOMINAL' }) + ` (${selectMultiPipeline.currencyCode})`,
                    value: `${data.nominal && currencyFormatter(data.nominal, selectMultiPipeline.currencyIsRounded, selectMultiPipeline.currencyCode, { showPrefix: true })}`,
                },
                product_qty: {
                    name: intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.SUM_PRODUCTS' }),
                    value: returnQtyProduct(data)
                },
                creator: {
                    name: intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.CREATED_BY' }),
                    value: data.creator_name
                },
                start_date: {
                    name: intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.DATE_STARTED' }),
                    value: moment(data.date_start).format("DD MMM YYYY HH:mm")
                },
                end_date: {
                    name: intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.DATE_ENDED' }),
                    value: data.date_end ? moment(data.date_end).format("DD MMM YYYY HH:mm") : "-"
                },
                note: {
                    name: user.data.company_id === companyId.elgisa ? "Opportunity" : intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.NOTES' }),
                    value: data.note ? <ExpandableElement text={(data.note).replaceAll('\n', '<br/>')} maxHeight={100} /> : "-"
                },
            }

            setSelectedDataPipeline(customData);
        }
    }, [selectedPipelineLogTemp, keyCustomfield])

    useEffect(() => {
        if (selectedPipelineLogTemp) {
            setSelectedPipelineLogTemp(null)
            setSelectedDataPipeline(null)
        }
    }, [])

    return (
        <ReactBootstrapModal
            show={showModal}
            onHide={() => {
                handleModalClose()
            }}
            centered
            backdrop='static'
            keyboard={false}
            size='xl'
            id='add-select-pipeline-modal'
        >
            <ReactBootstrapModal.Header
                closeButton
            >
                <ReactBootstrapModal.Title>
                    {intl.formatMessage({ id: "FORM.ACTION.CHOOSE" })} {settings.pipeline_title}
                </ReactBootstrapModal.Title>
            </ReactBootstrapModal.Header>
            <ReactBootstrapModal.Body>
                <div className='modal-body'>
                    <div className='row mb-3'>
                        <div className='col-md-6'>
                            <div className="input-group mb-3">
                                <label className='form-label'>{intl.formatMessage({ id: "FORM.ACTION.CHOOSE" })} {settings.pipeline_title}</label>
                                <VirtualizedSelect
                                    isDisabled={false}
                                    name="pipeline"
                                    placeholder={`${intl.formatMessage({ id: "FORM.ACTION.CHOOSE" })} ${settings.pipeline_title}`}
                                    options={dataOptionsPipeline}
                                    value={null}
                                    onChange={(option) => {
                                        handleChangeSelectedPipeline(option)
                                    }}
                                    onBlur={() => setSelectedPipelineLogTemp(null)}
                                    className="w-100"
                                    components={{
                                        Option: CustomSelectPipelineLogLead

                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        {
                            selectedDataPipeline && Object.keys(selectedDataPipeline).length > 0 && Object.keys(selectedDataPipeline).map((key, index) => {
                                return (
                                    <div className="row pb-2 col-12 col-lg-6 col-xl-6">
                                        <div className="col-3 text-end" style={{ fontWeight: "500", color: "#767373" }}>{selectedDataPipeline[key].name}</div>
                                        <div className="col-9" style={{ fontWeight: "500", color: "black" }}>{selectedDataPipeline[key].value}</div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
                <div className="modal-footer">
                    <button
                        type="button"
                        className="btn btn-light"
                        onClick={() => handleModalClose()}
                    >
                        {intl.formatMessage({ id: "FORM.ACTION.CANCEL" })}
                    </button>
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={() => {
                            setShowModalAddLog(true)
                            handleModalClose()
                        }}
                        disabled={!selectedPipelineLogTemp}
                    >
                        Lanjutkan
                    </button>
                </div>
            </ReactBootstrapModal.Body>
        </ReactBootstrapModal>
    )
}

export default BtnActionSelectPipeline